import React from 'react';
import { BadgeAlt as Badge } from '@cargomatic/ui';
import { cn } from 'utils/ui/classes';
function getColor(status) {
    switch (status) {
        case 'Service Watch':
            return 'bg-blue-100 text-blue-800 border-blue-300';
        case 'New Customer':
            return 'bg-blue-100 text-blue-800 border-blue-300';
        case 'Repeat Customer':
            return 'bg-green-100 text-green-800 border-green-300';
        default:
            return 'bg-gray-100 text-gray-800 border-gray-300';
    }
}
export default function ShipperStatusBadge({ className = '', status }) {
    if (!status)
        return null;
    return (React.createElement(Badge, { variant: "outline", className: cn('whitespace-nowrap self-start shrink-0 grow-0', getColor(status), className) }, status));
}
